import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Iframe from '@swf/components/Iframe/Iframe';

import { TXTMOB_Feedback } from './CesFeedbackForm.messages.json';
import { crm, embedder, line } from './CesFeedbackForm.scss';

interface Props {
  url: string;
}

const CesFeedbackForm: React.FC<Props> = ({ url }) =>
  url ? (
    <div className={crm} data-testid="ces-feedback-form">
      <span className={line}>
        <h2>
          <Translation tagName={'span'} {...TXTMOB_Feedback} />
        </h2>
        <div className={embedder}>
          <Iframe src={url} scrolling="no" />
        </div>
      </span>
    </div>
  ) : null;

export default CesFeedbackForm;
